"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  none: 'none',
  el1: '0px -0.5px 0px rgba(0, 23, 74, 0.02), 0px 1px 5px rgba(0, 23, 74, 0.14)',
  el2: '0px -0.5px 0px rgba(0, 23, 74, 0.02), 0px 1px 4px rgba(0, 23, 74, 0.08), 0px 3px 12px rgba(0, 23, 74, 0.12)',
  el3: '0px 1px 4px rgba(0, 23, 74, 0.04), 0px 4px 16px rgba(0, 23, 74, 0.16)',
  el4: '0px 2px 8px rgba(0, 23, 74, 0.04), 0px 6px 24px rgba(0, 23, 74, 0.2)',
  el5: '0px 4px 16px rgba(0, 23, 74, 0.06), 0px 8px 32px rgba(0, 23, 74, 0.2)'
};